import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    ClientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
        { type: 'required', message: 'Please provide a phone number' }
      ]
    },
    AccountExtra1: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' },
        { type: 'required', message: 'Please provide an event date' }
      ]
    },
    AccountExtra3: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' }
      ]
    },
    Category: {
      validations: [
        { type: 'required', message: 'Please select a style' }
      ]
    },
    AccountExtra2: {
      validations: [
        { type: 'required', message: 'Please provide information' }
      ]
    },
    Reference: {
      validations: []
    },
    notes: {
      validations: []
    },
    Operation: {
      validations: [
        { type: 'required', message: 'Please select a location' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Client/Organization:',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'AccountExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:*',
            mapping: 'AccountExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Style of Event:*',
            options:[
              {label: 'Corporate' , value: 'Corporate'},
              {label: 'Social' , value: 'Social'},
              {label: 'Wedding' , value: 'Wedding'},
              {label: 'Convention' , value: 'Convention'},
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Venue:*',
            mapping: 'AccountExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How Did You Hear About Us?',
            options: [
              {label: 'Online Search' , value: 'Online Search'},
              {label: 'Event Venue' , value: 'Event Venue'},
              {label: 'Repeat Customer' , value: 'Repeat Customer'},
              {label: 'Customer Referral' , value: 'Customer Referral'},
              {label: 'Employee Referral' , value: 'Employee Referral'},
              {label: 'Vendor Referral' , value: 'Vendor Referral'},
              {label: 'Social Media' , value: 'Social Media'},
              {label: 'The Knot' , value: 'The Knot'},
              {label: 'Wedding Wire' , value: 'Wedding Wire'},
              {label: 'Puff \'n Stuff Trucks' , value: 'Puff \'n Stuff Trucks'},
              {label: 'Yelp' , value: 'Yelp'},
              {label: 'Facebook Ads' , value: 'Facebook Ads'},
              {label: 'Online Ads' , value: 'Online Ads'},
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Comments/Message:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Location:*',
            options:[
              {label: 'Tampa' , value: 'Tampa'},
              {label: 'Orlando' , value: 'Orlando'},
              {label: 'Sarasota' , value: 'Sarasota'},
              {label: 'Jacksonville' , value: 'Jacksonville'},
            ],
            mapping: 'Operation'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Puff N Stuff Catering Contact Form',
    formId: '643',
    clientKey: 'A5392A21-8137-48A6-81A9-1855F7570EDF',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'http://puffnstuff.com/thankyou/',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
